import type { schemaType as strapiHomeSchemaType } from '~~/modules/api/strapi/home/schema'
import type { propsInterface } from '~~/modules/design-system/sections/s-cards-tiny-images/s-cards-tiny-images.vue'

export const useToSCardsTinyImages = () => {
  const fromStrapiHome = (data: strapiHomeSchemaType): propsInterface => {
    let items: propsInterface['items'] = []

    items = Object.values(data.attributes.featured_searches).map(item => {
      return {
        url: item.url,
        image: item.image.data[0].attributes.url,
        title: item.title,
      }
    })

    return { items }
  }
  return { fromStrapiHome }
}
